import { STAGES, stageMeta } from "../lib/stages";

export const StageBadge = ({ stage }) => {
  const m = stageMeta(stage);
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border ${m.color}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${m.dot}`} />
      {m.label}
    </span>
  );
};

export default function StageSelect({ value, onChange, testId }) {
  const m = stageMeta(value);
  return (
    <select
      data-testid={testId}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={`rounded-full text-xs font-semibold border px-2.5 py-1.5 cursor-pointer focus:outline-none appearance-none ${m.color} bg-transparent`}
      style={{ backgroundColor: "rgba(0,0,0,0.3)" }}
    >
      {STAGES.map((s) => (
        <option key={s.value} value={s.value} className="bg-[#0f2442] text-white">
          {s.label}
        </option>
      ))}
    </select>
  );
}
